'use strict';

import React from 'react';
import { Link } from 'react-router';
import Footer from './FooterComponent';
import UserStore from 'stores/UserStore';
import API from 'sources/API';
import UserActions from 'actions/UserActions';

import 'styles/Profile.scss';

class ProfileComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = UserStore.getState();
    this.state.moreIntro = false;
    this.state.userIntroModalOpen = false;
    this.state.currentTab = 'explore';
    this.onChange = this.onChange.bind(this);
    this.toggleUserIntroModal = this.toggleUserIntroModal.bind(this);
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        console.log(json);
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    window.scrollTo(0, 0);
    UserStore.listen(this.onChange);
    UserActions.fetchUser(this.props.params.id);
    UserActions.fetchAgent(this.props.params.id)

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onChange);
  }
  onChange(state) {
    if(!state.user_id && this.state.user_id){
      state.user_id = this.state.user_id
    }
    this.setState(state);
  }
  onTabChange(tab) {
    this.setState({currentTab: tab});
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.params.id !== nextProps.params.id) {
      if(nextProps.params.id) {
        this.setState({isProfile: false});
        UserActions.fetchUser(nextProps.params.id);
      } else {
        this.setState({isProfile: true});
        UserActions.fetchUser();
      }
    }
  }
  onFollowClick(type) {
    UserActions.postFollow(type);
  }
  componentDidUpdate() {
    let intro = document.querySelector('p.user-intro.fz12');
    if(intro.clientHeight > 34) {
      if(!this.state.moreIntro) {
        this.setState({moreIntro: true});
      }
    } else {
      if(this.state.moreIntro) {
        this.setState({moreIntro: false});
      }
    }
  }
  toggleUserIntroModal(event) {
    if(this.state.userIntroModalOpen) {
      this.setState({userIntroModalOpen: false});
    } else {
      this.setState({userIntroModalOpen: true});
    }
  }
  render() {
    let optBtn, userIntroModal;
    optBtn = (
      <Link to="/publish" className="publish"><i className="fa fa-camera fa-2"></i></Link>
    );
   
    if(this.state.userIntroModalOpen) {
      userIntroModal = (
        <div className="reveal-overlay">
          <div className="reveal" data-reveal>
            <button className="close-button" data-close aria-label="Close modal" type="button" onClick={this.toggleUserIntroModal}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="fz-14 text-gray">{this.state.user.summary}</p>
          </div>
        </div>
      );
    }
    let gender,img;
    if(this.state.user && this.state.user.gender === 0) {
      gender = <i className="ml-10 fz-12 fa fa-mars" aria-hidden="true"></i>
    } else if (this.state.user && this.state.user.gender === 1) {
      gender = <i className="ml-10 fz-12 fa fa-venus" aria-hidden="true"></i>
    }
    if(this.state.user){
      img = <img className="user-info-avatar contain" src={this.state.user.avatar} />
    }
    return (
      <div className="profile-component">
        {userIntroModal}
        <div className='row user-info'>
          {img}
          <div className="user-info-meta">
            <h4>
              {this.state.user ? this.state.user.name : ''}
              {gender}
              {optBtn}
            </h4>
            <p className="fz12">
              <span className="text-gray">博客: </span>
              <a className="mr15" target="_blank" href={this.state.user ? `http://${this.state.user.website}` : ''}>{this.state.user ? this.state.user.website : ''}</a>
              <span className="text-gray">位置: </span>
              <a href="" className="text-black">{this.state.user ? this.state.user.location : ''}</a>
            </p>
          </div>
          <p className={this.state.moreIntro ? 'user-intro fz12 text-gray moreIntro' : 'user-intro fz12 text-gray'} onClick={this.state.moreIntro ? this.toggleUserIntroModal : null}>{this.state.user && this.state.user.summary ? this.state.user.summary : <i>这里空空如也～</i>}</p>
        </div>
        <div className="separator"></div>
        <div className="tab-nav row expanded text-center">
          <div className="small-3 columns">
            <Link to="/orders/1" className="active"><i className="fa fa-history mr-5" aria-hidden="true"></i>待付款</Link>
          </div>
          <div className="small-3 columns">
            <Link to="/orders/2" className="active"><i className="fa fa-clock-o mr-5" aria-hidden="true"></i>拼团中</Link>
          </div>
          <div className="small-3 columns">
            <Link to="/orders/3" className="active"><i className="fa fa-plane mr-5" aria-hidden="true"></i>待出行</Link>
          </div>
          <div className="small-3 columns">
            <Link to="/orders/4" className="active"><i className="fa fa-comments-o mr-5" aria-hidden="true"></i>待评价</Link>
          </div>
        </div>
        <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-print" aria-hidden="true"></i></div>
            <Link to="/orders" className="title">全部订单</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
        </div>
        <div className="separator"></div>
        <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-paper-plane" aria-hidden="true"></i></div>
            <Link to="/opportunities" className="title">福利活动</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
        </div>
        <div className="separator"></div>
        <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-heart" aria-hidden="true"></i></div>
            <Link to="/favorites" className="title line">心愿单</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="cell">
            <div className="icon"><i className="fa fa-user" aria-hidden="true"></i></div>
            <Link to="/links" className="title">联系人</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
        </div>
        <div className="separator"></div>
        <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-sitemap" aria-hidden="true"></i></div>
            <Link to="/foots" className="title line">足迹</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="cell">
            <div className="icon"><i className="fa fa-bullseye" aria-hidden="true"></i></div>
            <Link to="/my/medias" className="title line">单点</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="cell">
            <div className="icon"><i className="fa fa-inbox" aria-hidden="true"></i></div>
            <Link to="/my/albums" className="title line">合辑</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="cell">
            <div className="icon"><i className="fa fa-database" aria-hidden="true"></i></div>
            <Link to="/collects" className="title">收藏</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="clear"></div>
        </div>
        <div className="separator"></div>
        <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-gavel" aria-hidden="true"></i></div>
            <Link to={`/businesses/${this.state.user_id}`} className="title line">店铺</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="cell">
            <div className="icon"><i className="fa fa-puzzle-piece" aria-hidden="true"></i></div>
            <Link to={this.state.agent.is_agent?`/agent/${this.state.user_id}`:'/agent/active'} className="title">代理</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
        </div>
        {/* <div className="separator"></div> */}
        {/* <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-user" aria-hidden="true"></i></div>
            <div className="title line">我的关注</div>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
          <div className="cell">
            <div className="icon"><i className="fa fa-user-secret" aria-hidden="true"></i></div>
            <div className="title">我的粉丝</div>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
        </div> */}
        <div className="separator"></div>
        <div className="navigations">
          <div className="cell">
            <div className="icon"><i className="fa fa-cog" aria-hidden="true"></i></div>
            <Link to ={'/setting'}className="title">设置</Link>
            <i className="fa fa-angle-right right-arrow" aria-hidden="true"></i>
          </div>
        </div>
        <div className="separator"></div>
        <div className="separator"></div>
        <Footer />
      </div>
    );
  }
}

ProfileComponent.displayName = 'ProfileComponent';

export default ProfileComponent;



// WEBPACK FOOTER //
// ./src/components/ProfileComponent.js